import { ICachedPermissionData } from "./models";
import { createSignal } from "../../utils/signalDispatcher";

export const cachedDataUpdatedSignal = createSignal<ICachedPermissionData>();

